export default __webpack_public_path__ + "static/media/keyUp.d1a59d75.svg";